import {showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage} from "@/state/alertHelpers";
import {
    getB2BOrders,
    getErpOrderDetails,
    getErpOrders,
    getPendingOrders,
    getSingleOrder,
    orderAdd,
    orderApprove,
    orderErpStatusChange, orderInvoiceControl,
    orderUpdate,
    orderELogo,
    getDemoProjectContract,
    getOrdersByProjectCode,
    orderDelete,
    orderDeliveryDateChange,
    getPendingOrdersSupplier,
    getPurchaseOrderList,
    // getPurchaseOrderSingle,
    purchaseOrderAdd, getPurchaseOrderSingle, itemStatusChange, orderStatusChange, purchaseOrderDelete, purchaseOrderApprove
    // deletePurchaseOrder
} from "@/services/modules/orders/orderService";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../helpers";
import Router from "@/router/index";
import store from "@/state/store";
import {swalToast} from "@/helpers/swalToast";


export const state = {
    noOrderMessage: "",
    erpOrders: [],
    erpOrdersHeaders: [],
    erpOrdersLoading: false,
    erpOrderDetails: [],
    erpOrderDetailsHeaders: [],
    erpOrderDetailsLoading: false,
    B2BOrders: [],
    B2BOrdersMetaData: {},
    B2BOrdersHeaders: [],
    B2BOrdersLoading: false,
    pendingOrders: [],
    pendingOrdersMetaData: {},
    pendingOrdersHeaders: [],
    pendingOrdersLoading: false,
    orderInvoiceControlLoading: false,
    erpOrdersELogo: {},
    demoProjectHTML: "",
    orderDeliveryDate: "",
    pendingOrdersSuppliers:[],
    pendingOrdersSuppliersHeaders:[],
    pendingOrdersSuppliersLoading:false,
    noPendingOrdersSuppliersMessage:"",
    pendingOrdersCart: [],
    pendingOrdersCartView: [],
    pendingOrdersProducts: [],
    pendingOrdersProductsLoading: false,
    purchaseOrders: [],
    purchaseOrdersHeaders: [],
    purchaseOrdersLoading: false,
    purchaseOrdersMetaData: [],
    noPurchaseOrdersMessage: "",
    purchaseOrderItemDetails: [],
    purchaseOrderItemDetailsHeaders: [],
    purchaseOrderItemDetailsLoading: false,
    noPurchaseOrderItemDetailsMessage: "",
};

export const mutations = {
    setNoOrderMessage(state, data) {
        state.noOrderMessage = data;
    },
    setErpOrders(state, data) {
        state.erpOrders = data;
    },
    setErpOrdersHeaders(state, data) {
        state.erpOrdersHeaders = data
    },
    setErpOrdersLoading(state, data) {
        state.erpOrdersLoading = data
    },
    setB2BOrders(state, data) {
        state.B2BOrders = data;
    },
    setB2BOrdersMetaData(state, data) {
        state.B2BOrdersMetaData = data;
    },
    setB2BOrdersHeaders(state, data) {
        state.B2BOrdersHeaders = data
    },
    setB2BOrdersLoading(state, data) {
        state.B2BOrdersLoading = data
    },
    setPendingOrders(state, data) {
        state.pendingOrders = data;
    },
    setPendingOrdersMetaData(state, data) {
        state.pendingOrdersMetaData = data;
    },
    setPendingOrdersHeaders(state, data) {
        state.pendingOrdersHeaders = data
    },
    setPendingOrdersLoading(state, data) {
        state.pendingOrdersLoading = data
    },
    setNoPendingOrdersSuppliersMessage(state, data) {
      state.noPendingOrdersSuppliersMessage = data;
    },
    setErpOrderDetails(state, data) {
        state.erpOrderDetails = data;
    },
    setErpOrderDetailsHeaders(state, data) {
        state.erpOrderDetailsHeaders = data
    },
    setErpOrderDetailsLoading(state, data) {
        state.erpOrderDetailsLoading = data
    },
    setOrderInvoiceControlLoading(state, data) {
        state.orderInvoiceControlLoading = data
    },
    setErpOrdersELogo(state, data) {
        state.erpOrdersELogo = data
    },
    setDemoProjectHTML(state, data) {
        state.demoProjectHTML = data;
    },
    setOrderDeliveryDate(state, data) {
        state.orderDeliveryDate = data;
    },
    setPendingOrdersSuppliers(state, data) {
        state.pendingOrdersSuppliers = data;
    },
    setPendingOrdersSuppliersHeaders(state, data) {
        state.pendingOrdersSuppliersHeaders = data;
    },
    setPendingOrdersSuppliersLoading(state, data) {
        state.pendingOrdersSuppliersLoading = data;
    },
    setPendingOrdersCart(state, data) {
        state.pendingOrdersCart = data;
    },
    setPendingOrdersCartView(state, data) {
        state.pendingOrdersCartView = data;
    },
    setPendingOrdersProducts(state, data) {
        state.pendingOrdersProducts = data;
    },
    setPendingOrdersProductsHeaders(state, data) {
        state.pendingOrdersProductsHeaders = data;
    },
    setPendingOrdersProductsLoading(state, data) {
        state.pendingOrdersProductsLoading = data;
    },
    setPurchaseOrders(state, data) {
        state.purchaseOrders = data;
    },
    setPurchaseOrdersHeaders(state, data) {
        state.purchaseOrdersHeaders = data;
    },
    setPurchaseOrdersLoading(state, data) {
        state.purchaseOrdersLoading = data;
    },
    setPurchaseOrdersMetaData(state, data) {
        state.purchaseOrdersMetaData = data;
    },
    setNoPurchaseOrdersMessage(state, data) {
        state.noPurchaseOrdersMessage = data;
    },
    setPurchaseOrderItemDetails(state, data) {
        state.purchaseOrderItemDetails = data;
    },
    setPurchaseOrderItemDetailsHeaders(state, data) {
        state.purchaseOrderItemDetailsHeaders = data;
    },
    setPurchaseOrderItemDetailsLoading(state, data) {
        state.purchaseOrderItemDetailsLoading = data;
    },
    setNoPurchaseOrderItemDetailsMessage(state, data) {
        state.noPurchaseOrderItemDetailsMessage = data;
    }
};

export const getters = {
    getLoading (state) {
        return state.pendingOrdersLoading;
    }
};

export const actions = {
    async fetchErpOrders(context, {params, body}) {
        let result = await getErpOrders(params, body);
        context.commit("setErpOrdersHeaders", [
            {
                key: 'orderNumber',
                label: 'Sipariş No',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'orderDate',
                label: 'Tarih',
                sortable: false,
                class: "text-center align-middle",

            }, {
                key: 'expiryDate',
                label: 'Vade Tarihi',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'currentCode',
                label: 'Cari Kodu',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'currentName',
                label: 'Cari Adı',
                sortable: false,
                class: "text-left align-middle",

            },
            {
                key: 'salesPersonCode',
                label: 'Plasiyer Kodu',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'salesPersonName',
                label: 'Plasiyer Adı',
                sortable: false,
                class: "text-left align-middle",

            },
            {
                key: 'totalAmount',
                label: 'Toplam Tutar',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'process',
                label: 'İşlem',
                sortable: false,
                class: "text-center align-middle",

            }
        ])
        if (result.data.success) {
            result.data.data.map(item => item.orderDate = formattedDate(item.orderDate, "DD-MM-YYYY"))
            result.data.data.map(item => item.expiryDate = formattedDate(item.expiryDate, "DD-MM-YYYY"))
            context.commit("setErpOrders", result.data.data);
        } else {
            context.commit("setNoOrderMessage", result.data.message);
            context.commit("setErpOrders", []);
        }
    },
    async invoiceControlOrder(context, {params, body}) {
        context.commit("setOrderInvoiceControlLoading", true);
        let result = await orderInvoiceControl(params, body);
        context.commit("setOrderInvoiceControlLoading", false);
        if (result.data.success) {
            await showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        } else {
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: ""
            })
        }
    },
    async fetchErpOrderDetails(context, {params, body, urlSegments}) {
        let result = await getErpOrderDetails(params, body, urlSegments);
        if (result.data.success) {
            result.data.data.map(item => item.quantity = numberConverter(item.quantity))
            result.data.data.map(item => item.grossPrice = numberConverter(item.grossPrice))
            result.data.data.map(item => item.netPrice = numberConverter(item.netPrice))

            result.data.data.map(item => item.discount = "%" + item.discount1 + " - " + "%" + item.discount2)
            context.commit("setErpOrderDetails", result.data.data);
            let headers = [
                {
                    key: 'stockCode',
                    label: 'Stok Kodu',
                    sortable: false,
                    class: 'text-center align-middle'


                },
                {
                    key: 'stockName',
                    label: 'Stok Adı',
                    sortable: false,
                    class: 'text-left align-middle'


                },
                {
                    key: 'quantity',
                    label: 'Miktar',
                    sortable: false,
                    class: 'text-center align-middle'


                },
                {
                    key: 'grossPrice',
                    label: 'Brüt Fiyat',
                    sortable: false,
                    class: 'text-center align-middle'


                },
                {
                    key: 'discount',
                    label: 'İskonto',
                    sortable: false,
                    class: 'text-center align-middle'
                },
                {
                    key: 'netPrice',
                    label: 'Net Fiyat',
                    sortable: false,
                    class: 'text-center align-middle'
                },
            ];
            if (store.state.settings.erpSettings.netsisCurrencySale) {
                let additionalHeaders = [
                    {
                        key: 'currencyPrice',
                        label: 'Dövizli Fiyat',
                        sortable: false,
                        visible: true,
                        class: "text-center align-middle",
                    }
                ];
                const indexOfBalance = headers.findIndex(header => header.key === 'netPrice');
                headers.splice(indexOfBalance + 1, 0, additionalHeaders.find((item) => item.key === 'currencyPrice'));
            }
            context.commit("setErpOrderDetailsHeaders", headers)
        } else {
            context.commit("setNoOrderMessage", result.data.message);
            context.commit("setErpOrders", []);
        }
    },
    async fetchB2BOrders(context, {params, body, urlSegments}) {
        context.commit("setB2BOrdersLoading", true);
        let result = await getB2BOrders(params, body, urlSegments);
        context.commit("setB2BOrdersLoading", false);
        if (result.data.success) {
            result.data.data.map(item => item.date = formattedDate(item.date, "DD-MM-YYYY HH:mm:ss"))
            context.commit("setB2BOrders", result.data.data);
            context.commit("setB2BOrdersMetaData", result.data);
            context.commit("setB2BOrdersHeaders", [
                {
                    key: 'orderNumber',
                    label: 'Sipariş No',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'erpOrderNumber',
                    label: 'ERP Sipariş No',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'date',
                    label: 'Tarih',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'user',
                    label: 'Siparişi Oluşturan',
                    sortable: false,
                    class: "text-center align-middle text-nowrap",

                },

                {
                    key: 'salesPersonName',
                    label: 'Plasiyer Adı',
                    sortable: false,
                    class: "text-left align-middle text-nowrap",

                },
                {
                    key: 'currentCode',
                    label: 'Cari Kodu',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'currentName',
                    label: 'Cari Adı',
                    sortable: false,
                    class: "text-left align-middle",

                },
                {
                    key: 'paymentMethod',
                    label: 'Ödeme Tipi',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'totalAmount',
                    label: 'Toplam Tutar',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'status',
                    label: 'Durumu',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'process',
                    label: 'İşlemler',
                    sortable: false,
                    class: "text-center align-middle",
                },
            ])
        } else {
            context.commit("setNoOrderMessage", result.data.message);
            context.commit("setB2BOrders", []);
            context.commit("setB2BOrdersMetaData", {});
        }
    },
    async fetchPendingOrders(context, {params, body}) {
        context.commit("setPendingOrdersHeaders", [
            {
                key: 'date',
                label: 'Tarih',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'stockCode',
                label: 'Stok Kodu',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'stockName',
                label: 'Stok Adı',
                sortable: false,
                class: "text-left align-middle",

            },
            {
                key: 'documentNumber',
                label: 'Sipariş No',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'quantity',
                label: 'Miktar',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'deliveryQuantity',
                label: 'Teslim Miktarı',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'remainingQuantity',
                label: 'Kalan Bakiye',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'currentName',
                label: 'Cari Adı',
                sortable: false,
                class: "text-left align-middle",

            },
            {
                key: 'salesPersonName',
                label: 'Plasiyer Adı',
                sortable: false,
                class: "text-left align-middle",

            },
            {
                key: 'unitPrice',
                label: 'Birim Fiyat',
                sortable: false,
                class: "text-right align-middle",

            },
            {
                key: "totalAmount",
                label: "Toplam Tutar",
                sortable: false,
                class: "text-right align-middle",
            },
            // {
            //     key: 'description',
            //     label: 'Açıklama',
            //     sortable: false,
            //     class: "text-left align-middle",
            //
            // },
            {
                key: "itemStatus",
                label: "Durum",
                sortable: false,
                class: "text-center align-middle"
            }
        ])
        context.commit("setPendingOrdersLoading", true);
        let result = await getPendingOrders(params, body);
        context.commit("setPendingOrdersLoading", false);
        if (result.data.success) {
            result.data.data.map(item => item.totalAmount = item.unitPrice * item.remainingQuantity );
            context.commit("setPendingOrders", result.data.data);
            context.commit("setPendingOrdersMetaData", result.data);
        } else {
            context.commit("setNoOrderMessage", result.data.message);
            context.commit("setPendingOrders", []);
            context.commit("setPendingOrdersMetaData", {});
        }
    },
    async fetchSingleOrder(context, {params, body, urlSegments}) {
        let result = await getSingleOrder(params, body, urlSegments);
        if (result.data.success) {
            //context.commit("setErpOrders",result.data.data);
            return result.data.data;
        } else {
            return false;
            //context.commit("setErpOrders",[]);
        }
    },
    async addOrder(context, {params, body, urlSegments}) {
        await showProcessPromptMessage({
            title: 'Siparişi Tamamla',
            text: "Siparişi tamamlamak istediğinize emin misiniz ?",
        }).then(async function (confirm) {
            if (confirm.isConfirmed) {
                let result = await orderAdd(params, body, urlSegments);

                if (result.data.success) {
                    await showProcessSuccessMessage({
                        title: 'Sipariş Tamamlandı',
                        text: "Sipariş işlemi başarılı",
                    })
                    await Router.push({name: 'b2bOrderList'})
                } else {
                    await showProcessErrorMessage({
                        title: 'Sipariş Tamamlama Başarısız',
                        text: result.data.message,
                    })
                }
                return result;
            }
        })

    },
    async approveOrder(context, {params, body, urlSegments}) {
        await showProcessPromptMessage({
            title: 'Sipariş Onaylanacak',
            text: "Siparişi onaylamak istediğinize emin misiniz ?",
        }).then(async function (confirm) {
            if (confirm.isConfirmed) {
                let result = await orderApprove(params, body, urlSegments);

                if (result.data.success) {
                    await showProcessSuccessMessage({
                        title: 'Sipariş Onaylandı',
                        text: "Sipariş onaylama işlemi başarılı",
                    })

                } else {

                    await showProcessErrorMessage({
                        title: 'Sipariş Onaylama Başarısız',
                        text: result.data.message,
                    })
                }
            }
        })

    },
    async erpStatusChangeOrder(context, {params, body}) {
        await showProcessPromptMessage({
            title: 'ERP Durum Değiştirme İşlemi',
            text: "İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
            if (confirm.isConfirmed) {
                let result = await orderErpStatusChange(params, body);

                if (result.data.success) {
                    await showProcessSuccessMessage({
                        title: 'ERP Durum Değiştirme İşlemi Başarılı',
                        text: "Durum değişikliği yapıldı",
                    })

                } else {
                    await showProcessErrorMessage({
                        title: 'ERP Durum Değiştirme İşlemi Başarısız',
                        text: result.data.message,
                    })
                }
            }
        })

    },
    async deleteOrder(context, {params, body}) {
        await showProcessPromptMessage({
            title: 'Sipariş İptal Ediliyor',
            text: "Siparişi iptal etmek istediğinize emin misiniz ?",
        }).then(async function (confirm) {
            if (confirm.isConfirmed) {
                let result = await orderDelete(params, body);

                if (result.data.success) {
                    await showProcessSuccessMessage({
                        title: 'Sipariş İptal Edildi',
                        text: "Sipariş iptal işlemi başarılı",
                    })

                } else {
                    await showProcessErrorMessage({
                        title: 'Sipariş İptal Başarısız',
                        text: result.data.message,
                    })
                }
            }
        })

    },
    async updateOrder(context, {params, body}) {
        let result = await orderUpdate(params, body);

        if (result.data.success) {
            await showProcessSuccessMessage({
                title: 'Sipariş Güncellendi',
                text: "Sipariş güncelleme işlemi başarılı",
            })

        } else {
            await showProcessErrorMessage({
                title: 'Sipariş Güncelleme Başarısız',
                text: result.data.message,
            })
        }

    },
    async fetchErpOrderELogo(context, {params, body}) {
        let result = await orderELogo(params, body);
        if (result.data.success) {
            context.commit("setErpOrdersELogo", result.data.data);
        }
        return result;
    },

    async fetchDemoProjectHTML(context, {params, body, urlSegments}) {
        context;
        let result = await getDemoProjectContract(params, body, urlSegments);

        if (result.data.success) {
            context.commit("setDemoProjectHTML", result.data.data.contractHtml);
            return result.data.data;
        } else {
            return [];
        }
    },
    async fetchOrdersByProjectCode(context, {params, body, urlSegments}) {
        context.commit("setB2BOrdersLoading", true);
        let result = await getOrdersByProjectCode(params, body, urlSegments);
        context.commit("setB2BOrdersLoading", false);
        if (result.data.success) {
            result.data.data.map(item => item.date = formattedDate(item.date, "DD-MM-YYYY HH:mm:ss"))
            context.commit("setB2BOrders", result.data.data);
            context.commit("setB2BOrdersMetaData", result.data);
            context.commit("setB2BOrdersHeaders", [
                {
                    key: 'orderNumber',
                    label: 'Sipariş No',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'erpOrderNumber',
                    label: 'ERP Sipariş No',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'date',
                    label: 'Tarih',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'user',
                    label: 'Siparişi Oluşturan',
                    sortable: false,
                    class: "text-center align-middle text-nowrap",

                },

                {
                    key: 'salesPersonName',
                    label: 'Plasiyer Adı',
                    sortable: false,
                    class: "text-left align-middle text-nowrap",

                },
                {
                    key: 'currentCode',
                    label: 'Cari Kodu',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'currentName',
                    label: 'Cari Adı',
                    sortable: false,
                    class: "text-left align-middle",

                },
                {
                    key: 'paymentMethod',
                    label: 'Ödeme Tipi',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'totalAmount',
                    label: 'Toplam Tutar',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'status',
                    label: 'Durumu',
                    sortable: false,
                    class: "text-center align-middle",

                },
                {
                    key: 'process',
                    label: 'İşlemler',
                    sortable: false,
                    class: "text-center align-middle",
                },
            ])
        } else {
            context.commit("setNoOrderMessage", result.data.message);
            context.commit("setB2BOrders", []);
            context.commit("setB2BOrdersMetaData", {});
        }
    },

    async updateOrderDeliveryDate(context, {params, body}) {
        let result = await orderDeliveryDateChange(params, body);

        if (result.data.success) {
            await swalToast.fire({
                icon: 'success',
                title: 'İşlem Başarılı',
                text: `${result.data.message}`,
                iconColor: "green"
            })

        } else {
            await swalToast.fire({
                icon: 'danger',
                title: 'İşlem Başarısız',
                text: `${result}`,
                iconColor: "green"
            })
        }
    },

    async getPendingOrdersSupplier(context, {params, body}) {
        let headers = [
            {
                value: 'code',
                text: 'Kod',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                value: 'name',
                text: 'Tedarikçi Adı',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                value: 'selection',
                text: 'Seç',
                sortable: false,
                class: "text-center align-middle",
            }
        ]
        context.commit("setPendingOrdersSuppliersHeaders",headers)
        context.commit("setPendingOrdersSuppliersLoading", true);
        let result = await getPendingOrdersSupplier(params, body);
        context.commit("setPendingOrdersSuppliersLoading", false);
        if (result.data.success) {
            context.commit("setPendingOrdersSuppliers", result.data.data);
            return result.data.data;
        } else {
            context.commit("setNoPendingOrdersSuppliersMessage", result.data.message);
            context.commit("setPendingOrdersSuppliers", []);
            return [];
        }
    },

    async addPurchaseOrder(context, {params, body}) {
        let result = await purchaseOrderAdd(params, body);
        if (result.data.success) {
            await showProcessSuccessMessage({
                title: 'Sipariş Eklendi',
                text: result.data.message
            })
            return result;
        } else {
            await showProcessErrorMessage({
                title: 'Sipariş Eklenemedi',
                text: result.data.message
            })
            return false;
        }
    },

    async getPendingOrdersProducts(context, {params, body}) {
        let headers = [
            {
                key: 'stockCode',
                value: 'Stok Kodu',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'stockName',
                value: 'Stok Adı',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'quantity',
                value: 'Miktar',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'unitPrice',
                value: 'Fiyat',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'add',
                value: 'Ekle',
                sortable: false,
                class: "text-center align-middle",
            },
        ]
        context.commit("setPendingOrdersProductsHeaders",headers)
        context.commit("setPendingOrdersProductsLoading", true);
        let result = await getPendingOrdersSupplier(params, body);
        context.commit("setPendingOrdersProductsLoading", false);
        if (result.data.success) {
            context.commit("setPendingOrdersProducts", result.data.data);
            return result.data.data;
        } else {
            context.commit("setNoOrderMessage", result.data.message);
            context.commit("setPendingOrdersProducts", []);
            return [];
        }
    },

    async fetchPurchaseOrders(context, {params, body}) {
        context.commit("setPurchaseOrdersHeaders", [
            {
                key: 'date',
                label: 'Tarih',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'orderNumber',
                label: 'Sipariş No',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'supplierCode',
                label: 'Tedarikçi Kodu',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'supplierName',
                label: 'Tedarikçi Adı',
                sortable: false,
                class: "text-left align-middle",
            },
            {
                key: 'erpOrderNumber',
                label: 'ERP Sipariş No',
                sortable: false,
                class: "text-left align-middle",
            },
            {
                key: 'salesPersonName',
                label: 'Plasiyer Adı',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'totalAmount',
                label: 'Toplam',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'description',
                label: 'Açıklama',
                sortable: false,
                class: "text-center align-middle",
            },
            {
                key: 'process',
                label: 'İşlemler',
                sortable: false,
                class: "text-center align-middle",
            },
        ])
        context.commit("setPurchaseOrdersLoading", true);
        let result = await getPurchaseOrderList(params, body);
        if (result.data.success) {
            result.data.data.map(item => item.date = formattedDate(item.date, "DD-MM-YYYY HH:mm:ss"));
            context.commit("setPurchaseOrders", result.data.data);
            context.commit("setPurchaseOrdersMetaData", result.data);
        } else {
            context.commit("setNoPurchaseOrdersMessage", result.data.message);
            context.commit("setPurchaseOrders", []);
        }
        context.commit("setPurchaseOrdersLoading", false);
    },

    async fetchSinglePurchaseOrder(context, {params, body,urlSegments}) {
        context.commit("setPurchaseOrderItemDetailsLoading", true);

        let headers = [
            {
                key: 'purchaseOrderId',
                label: 'Sipariş ID',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'stockCode',
                label: 'Stok Kodu',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'stockName',
                label: 'Stok Adı',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'unitPrice',
                label: 'Birim Fiyat',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'unit',
                label: 'Birim',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'quantity',
                label: 'Miktar',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'vat',
                label: 'KDV',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'vatAmount',
                label: 'KDV Tutarı',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'amount',
                label: 'Tutar',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'status',
                label: 'Durum',
                sortable: false,
                class: "text-center align-middle",
            }
        ];
        let headersWithCurrency = [
            {
                key: 'purchaseOrderId',
                label: 'Sipariş ID',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'stockCode',
                label: 'Stok Kodu',
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: 'stockName',
                label: 'Stok Adı',
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: 'unitPrice',
                label: 'Birim Fiyat',
                sortable: true,
                class: "text-center align-middle"
            },
            {
                key: 'unit',
                label: 'Birim',
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: 'quantity',
                label: 'Miktar',
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: 'vat',
                label: 'KDV',
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: 'amount',
                label: 'Tutar',
                sortable: true,
                class: "text-center align-middle"
            },
            // {
            //     key: 'currencyUnitPrice',
            //     label: 'Dövizli Birim Fiyatı',
            //     sortable: true,
            //     class: "text-center align-middle"
            // },
            // {
            //     key: 'currencyGrossAmount',
            //     label: 'Dövizli Brüt Tutar',
            //     sortable: true,
            //     class: "text-center align-middle"
            // },
            // {
            //     key: 'currencySubTotal',
            //     label: 'Dövizli Ara Tutar',
            //     sortable: true,
            //     class: "text-center align-middle"
            // },
            // {
            //     key: 'currencyTotalAmount',
            //     label: 'Dövizli KDV',
            //     sortable: true,
            //     class: "text-center align-middle"
            // },
            // {
            //     key: 'currencyTotalAmount',
            //     label: 'Dövizli Toplam Tutar',
            //     sortable: true,
            //     class: "text-center align-middle"
            // },
            {
                key: 'status',
                label: 'Durum',
                sortable: false,
                class: "text-center align-middle",
            }];
        if (this.state.settings.erpSettings.netsisCurrencySale) {
            context.commit("setPurchaseOrderItemDetailsHeaders", headersWithCurrency );
        } else context.commit("setPurchaseOrderItemDetailsHeaders", headers );
        let result = await getPurchaseOrderSingle(params, body,urlSegments);
        if (result.data.success) {
            result.data.data.orderItems.map(item => {
                if (item.units.includes(",")) {
                    let placement = item.units.indexOf(",")
                    item.unit = item.units.substring(0,placement)
                } else {
                    item.unit = item.units
                }
            });
            context.commit("setPurchaseOrderItemDetails", result.data.data);
        } else {
            context.commit("setNoPurchaseOrderItemDetailsMessage", result.data.message);
            context.commit("setPurchaseOrders", []);
        }
        context.commit("setPurchaseOrderItemDetailsLoading", false);
        // let currencies = [
        //     {
        //         key: 'currencyType',
        //         label: 'Para Birimi Türü',
        //         sortable: true,
        //         class: "text-center align-middle"
        //     },
        //     {
        //         key: 'currencyUnitPrice',
        //         label: 'Para Birimi Birim Fiyatı',
        //         sortable: true,
        //         class: "text-center align-middle"
        //     },
        //     {
        //         key: 'currencyVatAmount',
        //         label: 'Para Birimi KDV Tutarı',
        //         sortable: true,
        //         class: "text-center align-middle"
        //     },
        //     {
        //         key: 'currencyAmount',
        //         label: 'Para Birimi Tutarı',
        //         sortable: true,
        //         class: "text-center align-middle"
        //     },
        //     {
        //         key: 'currencyDiscountAmount1',
        //         label: 'Para Birimi İndirim Tutarı 1',
        //         sortable: true,
        //         class: "text-center align-middle"
        //     },
        //     {
        //         key: 'currencyDiscountAmount2',
        //         label: 'Para Birimi İndirim Tutarı 2',
        //         sortable: true,
        //         class: "text-center align-middle"
        //     }
        // ]


    },

    async deletePurchaseOrder(context, {params, body}) {
        await showProcessPromptMessage({
            title:"Sipariş  Silinecek",
            text:"Siparişi Silmek istediğinize emin misiniz?"
        }).then(async function(confirm){
            if (confirm.isConfirmed){
                let result = await purchaseOrderDelete(params,body);
                if (result.data.success){
                    showProcessSuccessMessage({
                        title:"İşlem Başarılı",
                        text:result.data.message,
                    })
                } else
                    showProcessErrorMessage(({
                        title: "İşlem Başarısız",
                        text: result.data.message,
                    }));
                return result;
            }
        })
    },


    async itemStatusChange(context, {params, body}) {
        let result = await itemStatusChange(params, body);
        if (result.data.success) {
            await showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        } else {
            await showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        }
    },
    async orderStatusChange(context, {params, body}) {
        let result = await orderStatusChange(params, body);
        if (result.data.success) {
            await showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        } else {
            await showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        }
    },

    async approvePurchaseOrder(context, {params, body,urlSegments}) {
        let result = await purchaseOrderApprove(params, body,urlSegments);
        if (result.data.success) {
            await showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        } else {
            await showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        }
    }

}